// Tooltip component scripts
// Credit: https://codepen.io/vincentnavetat/pen/JjPVzGL
(function() {
  class Tooltip extends HTMLElement {
    connectedCallback() {
      this.setup();
    }

    handleDropdownPosition() {
      const screenPadding = 0; // screen padding is moved to an actual padding value on the dropdown element using CSS
      
      this.dropdown.style = '';

      const placeholderRect = this.placeholder.getBoundingClientRect();
      const dropdownRect = this.dropdown.getBoundingClientRect();
      
      const dropdownRightX = dropdownRect.x + dropdownRect.width;
      const placeholderRightX = placeholderRect.x + placeholderRect.width;
      
      var viewportHeight;
      var viewportWidth;
      if (document.compatMode === 'BackCompat') {
          viewportHeight = document.body.clientHeight;
          viewportWidth = document.body.clientWidth;
      } else {
          viewportHeight = document.documentElement.clientHeight;
          viewportWidth = document.documentElement.clientWidth;
      }

      if (dropdownRect.x < screenPadding) {
        this.dropdown.style.left = '0';
        this.dropdown.style.right = 'auto';
        this.dropdown.style.transform = `translateX(${-placeholderRect.x + screenPadding}px)`;
      } else if (dropdownRightX > viewportWidth - screenPadding) {
        this.dropdown.style.left = 'auto';
        this.dropdown.style.right = '0';
        this.dropdown.style.transform = `translateX(${(viewportWidth - placeholderRightX) - screenPadding}px)`;
      }
    }

    toggle(e) {
      e.preventDefault();
      if (this.classList.contains('tooltip--open')) {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      this.handleDropdownPosition();
      this.classList.add('tooltip--open');
    }

    close() {
      this.classList.remove('tooltip--open');
    }

    setup() {
      this.placeholder = this.querySelector('[data-tooltip-target]');
      this.dropdown = this.querySelector('[data-tooltip-element]');

      this.placeholder.addEventListener('mouseover', () => this.handleDropdownPosition());
      this.placeholder.addEventListener('click', (e) => this.toggle(e));
    }
  }

  function dismissAllTooltips(event) {
    if (typeof event.target.closest !== 'function') return;
    const currentTooltip = event.target.closest('tooltip-component');

    document.querySelectorAll('.tooltip--open').forEach(tooltip => {
      if (tooltip === currentTooltip) return;

      tooltip.classList.remove('tooltip--open');
    });
  }

  customElements.define('tooltip-component', Tooltip);
  document.addEventListener('click', e => dismissAllTooltips(e));
})();

/* Option Info popup — open/close the dialog + move the CTA into the Globo options block */
(function () {
  var DIALOG_CLASS = 'option-info-dialog';
  var GLOBO_OPTIONS = '.gpo-element[data-element-id="checkbox-1"]';

  // Open / close via event delegation (keeps working after the CTA is relocated)
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-option-info-open]');
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-option-info-open'));
      if (dlg && typeof dlg.showModal === 'function') { dlg.showModal(); }
      return;
    }
    if (e.target.closest('[data-option-info-close]')) {
      var openDlg = e.target.closest('dialog');
      if (openDlg) { openDlg.close(); }
      return;
    }
    if (e.target.classList && e.target.classList.contains(DIALOG_CLASS)) {
      e.target.close(); // click on the backdrop
    }
  });

  // Relocate the CTA next to the Globo "Options" heading (Globo renders async)
  function placeTrigger() {
    var cta = document.querySelector('.option-info-trigger');
    if (!cta) return false;
    if (cta.dataset.placed === 'true') return true;
    var block = document.querySelector(GLOBO_OPTIONS);
    if (!block) return false;
    var label = block.querySelector('.gpo-label');
    (label || block).insertAdjacentElement(label ? 'afterend' : 'afterbegin', cta);
    cta.dataset.placed = 'true';
    return true;
  }

  function init() {
    if (placeTrigger()) return;                       // already available
    var observer = new MutationObserver(function () {
      if (placeTrigger()) observer.disconnect();      // stop once placed
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 10000); // safety cap
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();